import { render, staticRenderFns } from "./_fishing.vue?vue&type=template&id=610a3822&lang=pug&"
import script from "./_fishing.vue?vue&type=script&lang=js&"
export * from "./_fishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports